<template>
  <div class="workspace">
    <print-pdf-template v-if="print && monthDetail" :stripe-account="stripeAccount" :item="monthDetail"/>
    <div v-if="selectedRestaurant">
      <div class="section-heading">
        <h2>Financials</h2>
      </div>
      <div class="fcl-top">
        <h3>Payment Method: Weekly Direct Deposit</h3>
        <p>The income you earn through our system is automatically deposited into the bank account you specify on a
          weekly basis.</p>
      </div>
      <div class="monthly-statements">
        <h3>Monthly Invoices</h3>
        <p>Your monthly statements shown below</p>
        <div class="statement-table">
          <div class="statement-table-head">
            <div class="fcl-list-row">
              <div class="fcl-list-head-item">Month</div>
              <div class="fcl-list-head-item">Amount</div>
              <div class="fcl-list-head-item">Documents</div>
            </div>
          </div>
          <div class="statement-table-body">
            <div class="fcl-list-row" v-for="(month, index) in monthlies" :key="index" v-if="month[Object.keys(month)[0]].total > 0">
              <div class="fcl-list-body-item">{{ Object.keys(month)[0] }}</div>
              <div class="fcl-list-body-item">$ {{month[Object.keys(month)[0]].total}}</div>
              <div class="fcl-list-body-item cursor-pointer"><a @click="getMonthlyInvoicesLaunchPDF(month[Object.keys(month)[0]].index)"><i class="fas fa-file-alt"></i>
                Download Statement</a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="fcl-recent-deposits" >
        <div class="flex">
          <h3>Recent Deposits (Weekly)</h3>
          <select class="tr-input mx-2" v-model="selectedMonth">

            <option v-for="(option, index) in months"
                    :key="index"
                    v-if="index <= currentMonth"
                    :value="index">{{ option }}</option>
          </select>

        </div>
        <div class="fcl-list">
          <div class="fcl-list-head">
            <div class="fcl-list-row">
              <div class="fcl-list-head-item">Date</div>
              <div class="fcl-list-head-item">Distribution ID</div>
              <div class="fcl-list-head-item">Payment Amount</div>
            </div>
          </div>
          <div class="fcl-list-body">
            <financial-item v-for="transfer in weeklies" :key="transfer.start_date" :item="transfer" :stripe-account="stripeAccount" />
          </div>
          <div v-if="false">
            <div v-if="prev_obj !== first_obj" @click="getBalancePrev"><u>Prev</u></div>
            <div @click="getBalance"><u>Next</u></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      Select a restaurant to proceed
    </div>
  </div>
</template>

<script>
import printPdfTemplate from '../../layouts/components/pdf/printPdfTemplate'
import FinancialItem from './FinancialItem'
import moment from 'moment'

export default {
  name: 'Financials',
  data () {
    return {
      print: false,
      accountStatus: '',
      selectedMonth: moment().month(),
      transfers: null,
      monthlies: null,
      monthDetail: null,
      weeklies: null,
      stripeAccount: null,
      first_obj: null,
      last_obj: null,
      prev_obj: null
    }
  },
  components: {
    printPdfTemplate,
    FinancialItem,
    moment
  },
  mounted () {
    this.getStripeAccount()
    // this.getBalance()
    this.getMonthlyInvoices()
    this.getWeeklyInvoices()
  },
  computed: {
    months () {
      return moment.months()
    },
    currentMonth () {
      return moment().month()
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  watch: {
    selectedMonth () {
      this.getWeeklyInvoices()
    }
  },
  methods: {
    getWeeklyInvoices () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id,
        month: this.selectedMonth + 1
      }

      this.$vs.loading()
      this.$store.dispatch('api/getWeeklyInvoices', payload).then((response) => {
        if (response.data.status) {
          this.weeklies = response.data.data
        }
        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    getMonthlyInvoices () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id
      }

      this.$vs.loading()
      this.$store.dispatch('api/getMonthlyInvoices', payload).then((response) => {
        if (!response.data.status) {
          this.accountStatus = response.data.message
        } else {
          this.monthlies = response.data.data
        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    getMonthlyInvoicesLaunchPDF (index) {
      const payload = {
        restaurant_id: this.selectedRestaurant.id,
        month: index
      }

      this.$vs.loading()
      this.$store.dispatch('api/getMonthlyInvoices', payload).then((response) => {
        if (response.data.status) {
          this.monthDetail = response.data.data[0]
          this.printReceipt()
        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    getBalance () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id,
        page: this.last_obj,
        way: 'next',
        limit: 3
      }

      this.$vs.loading()
      this.$store.dispatch('api/getStripeTransfers', payload).then((response) => {
        if (!response.data.status) {
          this.accountStatus = response.data.message
        } else {
          this.accountStatus = 'Account: '
          this.transfers = response.data.data.data

          this.last_obj = this.transfers[this.transfers.length - 1].id
          this.prev_obj = this.transfers[0].id
          if (!this.first_obj) {
            this.first_obj = this.transfers[0].id
          }

        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },

    getBalancePrev () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id,
        page: this.prev_obj,
        way: 'prev',
        limit: 3
      }

      this.$vs.loading()
      this.$store.dispatch('api/getStripeTransfers', payload).then((response) => {
        if (!response.data.status) {
          this.accountStatus = response.data.message
        } else {
          this.accountStatus = 'Account: '
          this.transfers = response.data.data.data
          this.stripeAccount = response.data.data.account
          this.last_obj = this.transfers[this.transfers.length - 1].id
          this.prev_obj = this.transfers[0].id
        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },

    getStripeAccount () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id
      }

      this.$vs.loading()
      this.$store.dispatch('api/getStripeAccount', payload).then((response) => {
        if (!response.data.status) {
          this.accountStatus = response.data.message
        } else {
          this.accountStatus = 'Account: '
          this.stripeAccount = response.data.data
        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    printReceipt () {

      this.print = true
      setTimeout(() => {
        this.print = false
      }, 500)

    }
  }
}
</script>

<style lang="scss">

</style>
